module.exports = __webpack_public_path__ + "static/media/mainSlide1.230f904d.jpg";